import React, { useEffect, useRef } from "react";
import { useAuth } from "../../context/AuthContext";
import { useTour } from "../../context/TourContext";

const WelcomeGate = ({ user }) => {
  const { startTour, hasSeenTour } = useTour();
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (triggeredRef.current) return;
    if (!hasSeenTour()) {
      triggeredRef.current = true;
      startTour();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id]);

  return null;
};

const OnboardingLayer = () => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading || !isAuthenticated || !user) return null;

  return <WelcomeGate user={user} />;
};

export default OnboardingLayer;
